import React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import Item from './Item'

interface Props {
  estimatedMinutesForTheMonth: number
  scheduledOvertimeMinutes: number
}

const Breakdown = ({ estimatedMinutesForTheMonth, scheduledOvertimeMinutes }: Props) => {
  return (
    <Box width="full" gap="s4" paddingLeft="s24">
      <Item
        title={i18n.t('clock_in.sidepanel.planned.maximum_for_the_month')}
        value={estimatedMinutesForTheMonth}
      />
      {scheduledOvertimeMinutes > 0 && (
        <Item
          title={i18n.t('clock_in.sidepanel.planned.scheduled_overtime')}
          value={scheduledOvertimeMinutes}
        />
      )}
    </Box>
  )
}

export default Breakdown
